import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import { createScrollListener } from '../utils/scrollUtils';

const MainLayout = ({ children }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [showCookieBanner, setShowCookieBanner] = useState(true);
  
  useEffect(() => {
    // Use our throttled scroll listener for better performance
    const handleScroll = createScrollListener(() => {
      setIsScrolled(window.scrollY > 50);
    }, 100); // Throttle to 100ms
    
    window.addEventListener('scroll', handleScroll);
    
    // Apply global scroll padding to account for fixed header
    document.documentElement.style.scrollPaddingTop = '80px';
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Check if user has already accepted cookies
  useEffect(() => {
    const cookieAccepted = localStorage.getItem('cookieAccepted');
    if (cookieAccepted) {
      setShowCookieBanner(false);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieAccepted', 'true');
    setShowCookieBanner(false);
  };

  return (
    <div className="font-sans text-black min-h-screen flex flex-col">
      <Navigation isScrolled={isScrolled} />
      
      <main className="flex-grow">
        {children}
      </main>
      
      <Footer />
      
      {/* Cookie Banner */}
      {showCookieBanner && (
        <div className="fixed bottom-0 left-0 right-0 bg-primary text-white py-4 px-6 z-50">
          <div className="container mx-auto flex flex-col md:flex-row items-center justify-between">
            <div className="mb-4 md:mb-0 md:mr-8">
              <p className="text-sm">
                We use cookies to enhance your experience on our website. By continuing to browse this site, you agree to our use of cookies.
                <Link to="/cookies" className="underline ml-1 hover:text-accent">
                  Learn more
                </Link>
              </p>
            </div>
            <div className="flex">
              <button 
                onClick={acceptCookies} 
                className="bg-white text-primary px-4 py-2 rounded-md hover:bg-accent transition-colors"
              >
                Accept
              </button>
              <button 
                onClick={() => setShowCookieBanner(false)} 
                className="ml-4 flex items-center hover:text-accent"
              >
                <X size={18} />
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MainLayout;
